/**
 * @module components\ghTablePage
 */

import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Mixins, Model, Watch } from "vue-property-decorator";
import GhDialog from "../ghDialog/ghDialog";
import CreateService from "../mixins/service/createService";
import CustormQuery from "./custormQuery/custormQuery";

@Component({
  components: { CustormQuery }
})
export default class GhTablePage extends Mixins(CreateService) {
  @Model("change")
  private value!: object[];

  //#region props

  @Prop()
  private beforeRowIntial: (
    props: ITableRowProps
  ) => { [key: string]: ITableRowOption };

  @Prop({
    default: () => [
      { title: "数据维护", show: true },
      { title: "查看详情", show: false }
    ]
  })
  private tabs!: IGhTab[]; // tab列表

  @Prop({ default: true })
  private showTabs!: any;

  @Prop({ default: () => {} })
  private templateModel!: {}; // 新增数据模板

  @Prop()
  private beforeEditItem: (item) => void;

  //#endregion

  //#region 私有变量
  private currentModel = null; // 当前被选择的model

  private activatedTab = 0; // 当前激活的tab页

  private dlgRef = "editDialog"; // 编辑对话框引用

  private tableEvents = [];

  @Watch("tableEvents")
  private observeTableEvents() {
    let tb = this.$refs.table as Vue;
    if (tb) {
      for (const e of this.tableEvents) {
        tb.$off(e);
        tb.$on(e, item => this.$emit(e, item));
        try {
          let self = this;
          let m = eval("self." + e);
          if (m) {
            tb.$on(e, item => m(item));
          }
        } catch (error) {
          continue;
        }
      }
    }
  }

  @Watch("selectedItems")
  private observeSelectedItems() {
    this.$emit("change", this.selectedItems);
  }

  public get editProps() {
    if (this.tableConfig) {
      if (this.tableConfig.props) {
        return this.tableConfig.props;
      }
    }
  }

  private get headers() {
    if (this.tableConfig) {
      if (this.tableConfig.headers) {
        return this.tableConfig.headers;
      }
    }
    return [];
  }

  @Watch("tableConfig")
  private watchTableConfig() {
    this.$emit("update:tableConfig", this.tableConfig);
  }

  created() {
    if (this.sortBy) {
      this.pagination.sortBy = this.sortBy;
    }
    if (this.value) {
      this.selectedItems = this.value;
    }
  }

  //#endregion

  // 根据是否是home页选择可见tabs
  private get visibleTabs() {
    if (this.activatedTab === 0) {
      return [];
    } else {
      return this.tabs.slice(0, this.activatedTab + 1);
    }
  }

  private submitCustomQuery(conditions: IQueryCondtion[]) {
    this.custromQuery(conditions);
  }

  //#endregion

  //#region 界面交互主逻辑

  // 新增
  public addItem() {
    let editModel = {};
    Object.assign(editModel, this.templateModel);

    this.showDialog(editModel, "新增");
  }
  // 查看明细
  private viewItem(item) {
    if (this.tabs) {
      if (this.tabs.length > 1 && this.showTabs) {
        this.activatedTab += 1;
        this.currentModel = item;
      }
    }
    this.$emit("viewItem", item);
  }
  // 复制
  private copyItem(model) {
    if (model) {
      let editModel: IndexObject = {};
      Object.assign(editModel, model);
      delete editModel.Id;
      this.showDialog(editModel, "编辑");
    }
  }
  // 编辑
  private editItem(model) {
    if (model) {
      let edit = {};
      Object.assign(edit, model);
      this.showDialog(edit, "编辑");
    }
  }
  // 删除

  // 显示对话框
  private async showDialog(model, title?: string) {
    let dlg = this.$refs[this.dlgRef] as GhDialog;
    try {
      if (this.beforeEditItem) {
        this.beforeEditItem(model);
      }
      let res = await dlg.open(model, title);
      this.saveItem(res);
    } catch (error) {}
  }

  //#endregion

  private getModelTemplateName(prop: IProp) {
    return "model-prop-" + prop.value;
  }
  private getCellTemplateName(prop: ITableHeader) {
    return "table-cell-" + prop.value;
  }

  private onSuccessUpload(res) {
    this.$emit("on-success-upload", res);
  }
}
